import { useTheme } from '../theme/ThemeContext';
import { useState, useEffect, useRef } from 'react';
import { UMAP } from 'umap-js';
import UMAPScatterplot from './widgets/UMAPScatterplot';
import Dropdown from './widgets/dropdown';

export default function SubSampleUMAP({ multipleSamplesMetaData, multipleSamplesTaxaDataIndividual, isLoadingIndividualTaxa, possibleColorDict }) {
    const { theme } = useTheme();
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [rank, setRank] = useState("f");
    const [UMAPData, setUMAPData] = useState(null);
    const abortControllerRef = useRef(null);

    useEffect(() => {
        if (!multipleSamplesTaxaDataIndividual) return;

        setIsLoading(true);

        try {
            // extract taxonomic features for the selected rank
            // console.log(multipleSamplesTaxaDataIndividual);

            const features = multipleSamplesTaxaDataIndividual.map(sample => {
                // console.log(sample);

                const taxaAtRank = sample.taxonomic_data.filter(t => t.taxon.rank === rank);
                // console.log(taxaAtRank);
                console.log(taxaAtRank);


                const abundances = new Map();
                taxaAtRank.forEach(t => {
                    abundances.set(t.taxon.name, t.relative_abundance);
                });
                // console.log(taxaAtRank);


                return abundances;
            });


            const uniqueTaxa = new Set();
            features.forEach(f => {
                f.forEach((_, taxon) => uniqueTaxa.add(taxon));
            });

            const taxaArray = Array.from(uniqueTaxa);
            const vectors = features.map(f => {
                return taxaArray.map(taxon => f.get(taxon) || 0);
            });

            // Configure and run UMAP
            // const umap = new UMAP({
            //     nComponents: 2,
            //     nNeighbors: 15,
            //     minDist: 0.1,
            //     spread: 1.0,
            //     seed: 42,
            // });

            // option 1: global Structure Focus
            const umapConfig1 = {
                nComponents: 2,
                nNeighbors: 30,
                minDist: 0.05,
                spread: 1.5,
                metric: 'euclidean',
                random_state: 42
            };

            // option 2: local Structure Focus
            const umapConfig2 = {
                nComponents: 2,
                nNeighbors: 10,
                minDist: 0.01,
                spread: 0.8,
                metric: 'cosine',
                random_state: 42
            };

            // opption 3: balanced Approach
            const umapConfig3 = {
                nComponents: 2,
                nNeighbors: 15,
                minDist: 0.1,
                spread: 1.2,
                metric: 'correlation', // good for abundance patterns (Pearson correlation)
                random_state: 42
            };

            const umap = new UMAP(umapConfig3);

            const embedding = umap.fit(vectors);

            const umapData = embedding.map((coords, i) => ({
                sampleId: multipleSamplesMetaData[i].run_assembly_id,
                x: coords[0],
                y: coords[1],
                biome: multipleSamplesMetaData[i].meta_data.source_biome,
                color_hex: multipleSamplesMetaData[i].color_hex
            }));

            setUMAPData(umapData);
            setError(null);

        } catch (err) {
            console.error('UMAP computation error:', err);
            setError('Failed to compute UMAP projection');
        } finally {
            setIsLoading(false);
        }

    }, [multipleSamplesTaxaDataIndividual, rank]);

    const handleRankSelection = (item) => {
        const rankDict = {
            'phylum': 'p',
            'class': 'c',
            'order': 'o',
            'family': 'f',
            'genus': 'g',
            'species': 's'
        };
        setRank(rankDict[item]);
    };

    return (
        <div>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                margin: '10px 0',
                color: theme.colors.text,
            }}>
                <Dropdown
                    items={['phylum', 'class', 'order', 'family', 'genus', 'species']}
                    onSelect={handleRankSelection}
                    placeholder="family"
                    fontSize='14px'
                />
            </div>
            {isLoading ? (
                <p>Computing UMAP projection...</p>
            ) : UMAPData ? (
                <UMAPScatterplot
                    data={UMAPData}
                    possibleColorDict={possibleColorDict} />
            ) : (
                <p> </p>
            )}
        </div>
    );
}